/* 阶段 */
export enum Stage {
  /** 预热阶段 */
  preRegist = 1,
  /** 政府登记阶段 */
  regist = 2,
  /** 登记截止 */
  endRegist = 3,
}

/** 登记状态 */
export enum RegistState {
  /** 未登记 */
  unRegist = 0, // 未登记
  /** 已登记 */
  registed = 1, // 已登记
  /** 审核通过 */
  approved = 2, // 审核通过
  /** 已撤销（派券前） */
  undo = 3, // 已撤销（派券前）
  /** 已转移（派券前） */
  transfer = 4, // 已转移（派券前）
  /** 派券失败 */
  sendFail = 5, // 派券失败
  /** 消费券使用中 */
  sendSucc = 6, // 消费券使用中
  /** 消费券已被政府撤销 */
  sendUndo = 7, // 消费券已被政府撤销
  /** 消费券已被转移 */
  sendTransfer = 8, // 消费券已被转移
  /** 消费券已过期 */
  overdue = 9, // 消费券已过期
  /** 消费券预派发 */
  preSend = 10
}

export interface GovCVData {
  govCouponStage?: Stage; // 1 - 预热阶段（登记未开始） 2 - 登记阶段  3 - 登记截止
  state?: RegistState; // 	登记状态：0-未登记 1-已登记 2-审核通过 3-已撤销（派券前）4-已转移（派券前）5-派券失败 6-派券成功
  enhancedUid?: string; // 钱包账户号码(10位)
  regTime?: Date | undefined; // 登记时间
  confirmTime?: Date | undefined; // 审核通过时间
  dispatchTime?: Date | undefined; // 派券成功时间
  systemTime?: Date | undefined; // 系统时间
  dispatchFailReason?: string; // 派券失败的原因
  transationId?: string; // 用户在政府系统的transation_id
  couponBalance?: string; // 消费券余额 元
  couponExpireTime?: Date | undefined;  // 消费券失效时间
  userCvId?: string; // 用户消费券ID
  releaseAmount?: string; // 资金撤回金额 元 大于0表示有做过撤销
}

export interface StepInfo {
  type?: string;
  txt?: string;
  desc?: string;
  descLinkName?: string;
  descLink?: string;
  txtLinkName?: string;
  txtLink?: string;
}

export interface CVCardInfo {
  isInUse: boolean;
  isInWait: boolean;
  isInFail: boolean;
  isSendFail: boolean;
  isInExceptions: boolean;
  isOverdue: boolean;
  isLock: boolean;
  isFirstState: boolean;
  state?: RegistState;
  logo: string;
  cvName: string;
  desc: string;
  multiDesc: string;
  stateTips: string;
  balance?: string;
  releaseTips?: string;
  steps: StepInfo[];
}

/** 用户类型 */
export enum EUserType {
  empty = '', // 未知
  notPreRegistered = '0', // 未订阅
  newUser = '1',  // 登记阶段新用户
  oldUser = '2',  // 非新用户
}
/** 查询加码卡返回的信息 */
export interface IPromCVData {
  /** 登记状态 */
  state: RegistState;
  /** 活动阶段，1 - 预热阶段（登记未开始） 2 - 登记阶段  3 - 登记截止 */
  govCouponStage?: Stage;
  /** 消费券余额 */
  couponBalance: number;
  /** 消费券失效时间 */
  couponExpireTime?: Date | undefined;
  /** 用户消费券ID */
  userCvId?: string;
  /** 登记阶段是否新用户 */
  userType?: EUserType;
  /** 当前奖励所属的商户渠道 */
  spChannel?: string;
}

/** 奖励类型 */
export enum ERewardType {
  register = 1, // 注册奖励
  invite = 2, // 邀请奖励
  niudan = 3, // 扭蛋奖励
  movein = 4, // 转移入金
}
/** 奖励流水项 */
export interface IRewardItem {
  awardId: string;  // id
  type: ERewardType; // 1 - 注册奖励 2 - 邀请奖励 3 - 扭蛋奖励 4 - 转移入金
  helperNickName: string; //  昵称
  amt: number;  // 金额
  state: string;  // 状态 1 – 正常 2 – 作废
  createTime: string; // 创建时间
  modifyTime: string; // 修改时间
}
/** 查询奖励流水，出参 */
export interface IRewardList {
  num: number;
  rewardList: IRewardItem[];
}

export type RefundCvType = {
  cvStatus: CvStatus, // 券批次状态：1–预派发 | 2–派发 | 3-下线
  /**
   * 消费券状态：
   * 交易状态：1:使用中 | 2:已废弃 | 3:已转移
   * 对于已经废弃的用户消费券，不可以再进行延期/充值操作。
   * 已废弃的券，可进入回收状态： 91:政府回收中 | 92:资金已回退政府
  */
  transState: string,
  ownState: string, // 消费券转移状态：1 - 初始状态 | 2 - 转移/转赠中 | 3 - 转移/转增完成（对方点击领取）
  createTime: string, // 创建时间
  validTime: string, // 有效期
  expireTime: string, // 过期时间
  userCvId: string, // 用户券ID
  cvId: string, // 券批次号
  cvType: CvType, // 券类型：政府消费券：平台消费券
  cvName: string, // 券名称
  balance: string, // 余额
};
export enum CvType {
  govRefund = '4001'
}
/**
 * 券批次状态：1–预派发 | 2–派发 | 3-下线
*/
export enum CvStatus {
  PreFetch = '1',
  Fetched = '2',
  Offline = '3'
}
/**
 * 消费券状态：
*/
export enum CvTransState {
  /** 使用中 */
  Using = '1',
  /** 已废弃 */
  Abandoned = '2',
  /** 已转移 */
  Transfer = '3',
  /** 政府回收中 */
  GovRecall = '91',
  /** 资金已回退政府 */
  GovRefunded = '92'
}
/**
 * 消费券转移状态
*/
export enum CvOwnState {
  /** 初始状态 */
  Normal = '1',
  /** 转移/转赠中 */
  Transfering = '2',
  /** 转移/转增完成 */
  Transfered = '3',
}
/**
 * 详情页入口来源
*/
export enum DetailFrom {
  GovRefund = 'gov-refund'
}

/** 消费券 */
export interface VoucherItem {
  /** 券批次状态 */
  cvStatus: VoucherStatus
  /** 消费券状态 */
  transState: VoucherTransState
  /** 消费券转移状态 */
  ownState: VoucherOwnState
  /** 余额 */
  balance: string
  /** 原始余额 */
  srcBalance?: string
  /** 创建时间 */
  createTime: string
  /** 有效期 */
  validTime: string
  /** 过期时间 */
  expireTime: Date | undefined,
  srcExpireTime?: string,
  /** 用户券ID */
  userCvId: string
  /** 券批次号 */
  cvId: string
  /** 券logo */
  cvIcon: string
  /** 券描述 */
  cvName: string
  /** 券描述 */
  cvDesc: string
  /** 券类型 */
  cvType: VoucherType
  /** 是否推荐该券 */
  recommend: string
  /** 若是主动领取消费券，则该字段是点击领取的时间，被动领取与FcreateTime相同。 */
  receiveTime: string
  /** 修改时间 */
  modifyTime: string
  /** 累积实际撤回金额 */
  releaseAmount: string
  /** 废除渠道 */
  deleteChannel: string
  /** 累计已使用金额 */
  totalUsedBal: string
  /** 券类型 */
  cvFlag?: string
  /** 券的状态 */
  cvState?: RegistState
  /** 排序号 */
  sortNum?: number
}

export interface GovData2022 {
  govCouponStage: Stage; // 1 - 预热阶段（登记未开始） 2 - 登记阶段  3 - 登记截止
  state: RegistState; // 	登记状态：0-未登记 1-已登记 2-审核通过 3-已撤销（派券前）4-已转移（派券前）5-派券失败 6-派券成功
  enhancedUid: string; // 钱包账户号码(10位)
  regTime?: Date | undefined; // 登记时间
  confirmTime?: Date | undefined; // 审核通过时间
  dispatchTime?: Date | undefined; // 派券成功时间
  systemTime?: Date | undefined; // 系统时间
  dispatchFailReason?: string; // 派券失败的原因
  transationId?: string; // 用户在政府系统的transation_id
  /** 登记阶段是否新用户 */
  userType?: EUserType
  couponBalance?: string
  /** 是否可以展示派券成功弹窗了 */
  needShowSuccDialog?: boolean
}

export interface GovCVDataRes2022 {
  govData: GovData2022,
  allList: VoucherItem[]
  voucherItemList: VoucherItem[],
  expiredVoucherItemList: VoucherItem[]
}

/** 券批次状态 */
export enum VoucherStatus {
  /** 预派发 */
  PRE_SEND = '1',
  /** 派发成功 */
  RECEIVED = '2',
  /** 下线 */
  OFFLINE = '3',
}

/** 消费券状态 */
export enum VoucherTransState {
  USING = '1',
  ABANDON = '2',
  TRANS = '3',
  GOV_RECALL = '91',
  GOV_CALLBACK = '92'
}

/** 消费券转移状态 */
export enum VoucherOwnState{
  /** 初始状态 */
  INIT = '1',
  /** 转移/转赠中 */
  TRANS_ING = '2',
  /** 转移/转增完成（对方点击领取） */
  TRANS_RECEIVED = '3'
}

/** 消费券类别 */
export enum VoucherType{
  GOV = '4001',
  PROM = '4002'
}

/** 消费券列表请求接口type类型 */
export enum ListParamType{
  ALL = 0,
  NORMAL = 1,
  EXPIRED = 2,
  REFUND = 4,
}

/** 2022政府数据 */
export type GovCVData2022<T = GovCVData> = {
  govData: T,
  expiredGovData?: T,
  voucherItemList?: VoucherItem[]
};

/** 2022政府券类型 */
export enum CouponType {
  /** 政府消费券 */
  GOV_COUPON = '0',
  /** 退款消费券 */
  REFUND_COUPON = '1',
  /** 加码消费券 */
  PROM_COUPON = '2'
};
